module.exports = __webpack_public_path__ + "static/media/career-pathways.cf5c4274.gif";